module.exports = __webpack_public_path__ + "static/media/PALOSANTO_07.31df9eac.png";